import { P2pUseCase, UseCaseType } from "~/types";

// One dropdown covers both the messaging type and the p2p use case: the first
// entry is plain A2P, every other entry is one of the company's P2P use cases.
export type MessagingUseCaseOption = {
  label: string;
  // "a2p" for the A2P entry, otherwise the p2p use case id
  value: string;
  useCaseType: UseCaseType;
  // passed as p2p_nnid to the sms enablement endpoint, only set for p2p entries
  nnid: string | null;
};

export type MessagingUseCaseOptionGroup = {
  label: string;
  options: MessagingUseCaseOption[];
};

export const A2P_OPTION: MessagingUseCaseOption = {
  label: "A2P",
  value: "a2p",
  useCaseType: "a2p",
  nnid: null,
};

export function buildMessagingUseCaseOptions(
  p2pUseCases: P2pUseCase[]
): MessagingUseCaseOptionGroup[] {
  const p2pOptions = p2pUseCases.map((useCase) => ({
    label: useCase.name || "Unnamed use case",
    value: useCase.id,
    useCaseType: "p2p" as UseCaseType,
    nnid: useCase.nnid,
  }));

  return [
    { label: "A2P", options: [A2P_OPTION] },
    { label: "P2P use cases", options: p2pOptions },
  ];
}

export function flattenMessagingUseCaseOptions(
  groups: MessagingUseCaseOptionGroup[]
): MessagingUseCaseOption[] {
  return groups.flatMap((group) => group.options);
}
